<template>
<div>
  <img v-if="isShowLoadingIcon" src="../../assets/loader.gif" alt="Loader spinner" :style="{'height': height + 'px', 'width': width + 'px'}">
</div>
</template>

<script>

export default {
  name: 'LoaderSpinner',
  props: {
    height: {
      type: Number,
      default: 250
    },
    width: {
      type: Number,
      default: 250
    },
    hideIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isShowLoadingIcon () {
      return this.$route.name === 'homepage' ? false : this.hideIcon
    }
  }
}
</script>

<style scoped>
</style>
